var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var CardToolbar = function (_React$Component) {
  _inherits(CardToolbar, _React$Component);

  function CardToolbar() {
    _classCallCheck(this, CardToolbar);

    return _possibleConstructorReturn(this, (CardToolbar.__proto__ || Object.getPrototypeOf(CardToolbar)).apply(this, arguments));
  }

  _createClass(CardToolbar, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cf-card__toolbar' },
        React.createElement(
          'div',
          { className: 'cf-card__toolbar_controls' },
          this.props.controls
        ),
        React.createElement(
          'div',
          { className: 'cf-card__toolbar_links', role: 'tablist' },
          this.props.links
        )
      );
    }
  }]);

  return CardToolbar;
}(React.Component);

CardToolbar.propTypes = {
  controls: PropTypes.any,
  links: PropTypes.any
};

export default CardToolbar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardToolbar.js
// module id = 615
// module chunks = 0